import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {DumpsterFire} from "../../DumpsterFire";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {DumpsterFireSymbol} from "../../reels/DumpsterFireSymbol";


export class DFAvalancheFillUpReelsPresentation implements FlowStatePresentation {
    private _controller: FlowStateController;
    private _tl: TimelineLite;

    get hasAnticipation(): boolean {
        return !DumpsterFire.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
    }

    public start(controller: FlowStateController): void {
        this._tl = new TimelineLite({
            delay: 0.5,
            onStart: () => {
                this._tl.add(DumpsterFire.reelAnticipation.showContainer(), 0);
                DumpsterFire.model.firstReelFillUp = true;
            },
            onComplete: () => {
                controller.setSkipCallback();
                this.completePresentation(controller);
            }
        });
        this._controller = controller;
        this._tl.add(() => {
            controller.setSkipCallback(() => {
                this.skip();
            });
        });
        this._tl.add(DumpsterFire.reelAnticipation.reset(true), 0);
        for (let i: number = 0; i < DumpsterFire.model.symbolCollapsed.length; i++) {
            if (DumpsterFire.model.symbolCollapsed[i] && !DumpsterFire.apiPlugin.settings.get(APISetting.FAST_SPIN, false) && DumpsterFire.model.scatterCount < 5 && DumpsterFire.model.scatterCount > 1) {
                this._tl.add(() => {
                    DumpsterFire.reelAnticipation.update(i);
                }, 0);
                break;
            }
        }
        this._tl.add(DumpsterFire.allReelsView.fillUp());
    }

    private completePresentation(flowStateController: FlowStateController): void {
        DumpsterFire.model.symbolCollapsed = [false, false, false, false, false, false];
        DumpsterFire.model.upgradeAvalancheStop = false;
        flowStateController.finish();
    }

    private skip(): void {
        this._tl.timeScale(2);
    }
}